import React, {useEffect, useState } from "react";
import { Card, CardBody, Media } from "reactstrap";
import {
  getBaseUrl,
  daysNameEvaluation,
  monthNames,
} from "../../../../actions/utility";
import ChaptersAccordion from "./ChaptersAccordion";
import yTubeIcon from "../../../../public/images/youtubeIcon.svg";
import worksheetIcon from "../../../../public/images/google-docs.png";
import customerIcon from "../../../../public/images/customer-support.png";
import logo from "../../../../public/images/logo512.png";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import $ from 'jquery';

const InvoiceFeed = (props) => {
  const { item } = props;
  const { feed_data } = item;
  const [showChapters, setshowChapters] = useState(false);

  useEffect(() => {
    // Initialize the tooltip
    $('[data-toggle="tooltip"]').tooltip();
    
    // Apply custom style to tooltip
    $('[data-toggle="tooltip"]').on('shown.bs.tooltip', function () {
      const tooltipInner = document.querySelector('.tooltip-inner');
      if (tooltipInner) {
        tooltipInner.style.fontSize = '8px';
      }
    });

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      $('[data-toggle="tooltip"]').on('click', function () {
        const element = $(this);
        element.tooltip('show');
        
        setTimeout(() => {
          element.tooltip('hide');
        }, 2000); // Hide tooltip after 2 seconds
      });
    }

  }, []);
  
  const TDate = (scheduledTime) => {
    var ToDate = new Date();

    if (new Date(scheduledTime).getTime() <= ToDate.getTime()) {
      // alert("The Date must be Bigger or Equal to today date");
      return true;
    }
    return false;
  };
  const currentTimeZone = moment.tz.guess();

  return (
    <Card
      style={{
        marginBottom: "2vh",
        border: "1px #ccc solid",
        textAlign: "left",
      }}
      className="homeSection"
      id={item.user_feedid}
    >
      <CardBody>
        <div className="d-flex tutorImageSection">
          <div>
            {item?.teacher_image ? (
              <img
                className=""
                src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.teacher_image}`}
                width="40"
                height="40"
              />
            ) : (
              <img className="" src={logo} width="40" height="40" />
            )}
          </div>
          <div className="ml-2">
            <label>
              {item?.teacher_name ?? "LM"}
              <strong> shares </strong>
            </label>{" "}
            <br />
            <span className="gradeName text-primary">
              {item?.course_name ?? "Invoice"}
            </span>
            <span style={{ fontSize: 10 }}  data-toggle="tooltip" data-placement="bottom" title={item.created_at}>
              {moment
                .tz(item.created_at, "Asia/Karachi")
                .tz(currentTimeZone)
                .fromNow()}
            </span>
          </div>
        </div>
        <div className="mt-3 mb-2">
        {JSON.parse(feed_data)?.[0]
                ?.message.split("/n")
                .map((part, index) => {
                  if (part.match(/^https?:\/\//i)) {
                    return (
                      <a
                        key={index}
                        href={part}
                        target="__blank"
                        className="mr-1"
                      >
                        {part}
                      </a>
                    );
                  } else {
                    return (
                      <span
                      style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
                      dangerouslySetInnerHTML={{ __html: part }}
                    ></span>
                    );
                  }
                })}
          {/* <span
            style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
            dangerouslySetInnerHTML={{
              __html: JSON.parse(feed_data)?.[0]?.message,
            }}
          ></span> */}
        </div>
        <div className="mb-2 text-right">
          <a target="__blank" href={`/#/${item?.student_id}/invoices/63427768772`}>
            <button className="viewInvoiceBtn">View your Invoices</button>
          </a>
        </div>
        {JSON.parse(feed_data)?.[0]?.url_type == "image" ? (
          <div className="border text-center">
            <img src={JSON.parse(feed_data)?.[0]?.url} width="100%" />
          </div>
        ) : JSON.parse(feed_data)?.[0]?.url_type == "text" ? (
          <div>
            <label>{JSON.parse(feed_data)?.[0]?.message}</label>
          </div>
        ) : (
          <div className="border text-center">
            <video width="100%" controls>
              <source
                src={JSON.parse(feed_data).url}
                // src={
                //   "https://lincolnmethod.s3.amazonaws.com/influencer/Demo+Scheduled.mp4"
                // }
                type="video/mp4"
              />
              Your browser does not support HTML video.
            </video>
          </div>
        )}

        {/* Irrelevant for this invoice feed */}
        {item.is_zoom == 1 ? (
          <>
            {TDate(item.scheduled_date_time) ? (
              <div className="mt-3">
                <label className="font-weight-bold">
                  Your class was on:
                </label>
                <p>
                  Date:{" "}
                  {
                    daysNameEvaluation[
                      new Date(item.scheduled_date_time).getDay()
                    ]
                  }{" "}
                  {new Date(item.scheduled_date_time).getDate()}{" "}
                  {monthNames[new Date(item.scheduled_date_time).getMonth()]}{" "}
                  <br />
                  Time:{" "}
                  {new Date(item.scheduled_date_time).toLocaleTimeString(
                    "en-US",
                    {
                      hour: "2-digit",
                      minute: "2-digit",
                    }
                  )}{" "}
                  <br />
                  Teacher: {item.teacher_name}{" "}
                </p>
              </div>
            ) : (
              <>
                <div className="mt-3">
                  <label className="font-weight-bold">
                    Your demo class is on:
                  </label>
                  <p>
                    Date:{" "}
                    {
                      daysNameEvaluation[
                        new Date(item.scheduled_date_time).getDay()
                      ]
                    }{" "}
                    {new Date(item.scheduled_date_time).getDate()}{" "}
                    {monthNames[new Date(item.scheduled_date_time).getMonth()]}{" "}
                    <br />
                    Time:{" "}
                    {new Date(item.scheduled_date_time).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )}{" "}
                    <br />
                    Teacher: {item.teacher_name}{" "}
                  </p>
                </div>
                <button
                  className="btn btn-success zoomBtn"
                  onClick={() => window.open(item.zoomlink, "_blank")}
                >
                  Click to join your class online
                </button>
              </>
            )}
          </>
        ) : null}
        {item.feed_label == "start_class" && item.zoomlink ? (
          <>
            <label>Topic(s) covered in class today:</label>
            <br />
            <label className="mb-0 font-weight-bold">
              {" "}
              <i className="fa fa-commenting mr-2 text-success fa-2x"></i>
              Place Value Models - Tens & Ones
            </label>
            <p
              className="text-italic ml-4"
              style={{ fontSize: 12, color: "#c1c1c1" }}
            >
              (Chapter: Place values)
            </p>
            <label>Worksheet(s):</label>
            <div className="row">
              <div className="col-12">
                <Media
                  width={20}
                  height={20}
                  object
                  src={worksheetIcon}
                  alt={worksheetIcon}
                />
                <label className="ml-2">
                  <a href={"localhost"} target="_new">
                    Identify units
                  </a>
                </label>
              </div>
              <div className="col-12">
                <Media
                  width={20}
                  height={20}
                  object
                  src={worksheetIcon}
                  alt={worksheetIcon}
                />
                <label className="ml-2">
                  <a href={"localhost"} target="_new">
                    Place Value Models - Tens & Ones
                  </a>
                </label>
              </div>
              <div className="col-12">
                <Media
                  width={20}
                  height={20}
                  object
                  src={worksheetIcon}
                  alt={worksheetIcon}
                />
                <label className="ml-2">
                  <a href={"localhost"} target="_new">
                    Place Value - Tens & Ones
                  </a>
                </label>
              </div>
            </div>
            <label>Video(s):</label>
            <div className="row">
              <div className="col-12">
                <Media
                  width={20}
                  height={20}
                  object
                  src={yTubeIcon}
                  alt={yTubeIcon}
                />
                <label className="ml-2">
                  <a href={"localhost"} target="_new">
                    Counting in Tens
                  </a>
                </label>
              </div>
              <div className="col-12">
                <Media
                  width={20}
                  height={20}
                  object
                  src={yTubeIcon}
                  alt={yTubeIcon}
                />
                <label className="ml-2">
                  <a href={"localhost"} target="_new">
                    Carrying Ones forward
                  </a>
                </label>
              </div>
              <div className="col-12">
                <Media
                  width={20}
                  height={20}
                  object
                  src={yTubeIcon}
                  alt={yTubeIcon}
                />
                <label className="ml-2">
                  <a href={"localhost"} target="_new">
                    Lets talk about Ones and Tens
                  </a>
                </label>
              </div>
            </div>
            <br />
            <button
              className="btn btn-success zoomBtn mt-5"
              onClick={() => window.open(item.zoomlink, "_blank")}
            >
              Click to join your class online
            </button>
          </>
        ) : null}

        {item.is_practice == 1 ? (
          <>
            <button
              className={
                showChapters
                  ? "btn takeTest mt-3"
                  : "btn btn-success zoomBtn mt-3"
              }
              onClick={() => setshowChapters(!showChapters)}
            >
              {showChapters
                ? "Select a chapter and a topic below"
                : "Take a practice test while you wait"}
            </button>
            {showChapters ? (
              <ChaptersAccordion
                programId={item.prog_id}
                studentId={item.student_id}
              />
            ) : null}
          </>
        ) : null}
      </CardBody>
      <div className="zoomSection">
        {/* <label>{timeLabel} {timerComponents}</label> <br />
                                <button className="btn btn-success zoomBtn" onClick={() => window.open(item.zoomlink, '_blank')}>Click to join your class online</button> */}
      </div>
    </Card>
  );
};

export default InvoiceFeed;
